import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

if (document.querySelector('[data-collection-slider]')) {
    // eslint-disable-next-line no-unused-vars
    const slider = new Swiper('[data-collection-slider]', {
        breakpoints: {
            320: {
                direction: 'horizontal',
                slidesPerView: 'auto',
                threshold: 20,
                spaceBetween: 8,
            },
            1024: {
                spaceBetween: 16,
                slidesPerView: 6,
                centerInsufficientSlides: true,
                watchOverflow: true,
            },
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}
